import type { Axios } from "axios";
import type { UseQueryOptions } from "@tanstack/react-query";
import type { Community } from "@/models";

export const getCommunitiesForSelection = async (
  axiosInstance: Axios
): Promise<Community[]> => {
  try {
    const response = await axiosInstance.get<Community[]>(
      `/communities/for-selection`
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching community with communities:`, error);
    throw error;
  }
};

export const getCommunitiesForSelectionQuery = (
  axiosInstance: Axios
): UseQueryOptions<Community[]> => ({
  queryKey: ["communities-for-selection"],
  queryFn: () => getCommunitiesForSelection(axiosInstance),
  staleTime: 1000 * 60 * 60 * 8 // 8 hours
});
